import { approvalsListApprovalsQueryKey } from '@column/api';

export const approvalListsFilter = {
  predicate: ({ queryKey }: { queryKey: readonly unknown[] }) =>
    (queryKey[0] as { _id?: string } | undefined)?._id === approvalsListApprovalsQueryKey()[0]._id,
};
